import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="min-h-screen flex items-center justify-center py-8">
      <div className="container">
        <div className="card card-lg text-center" style={{ maxWidth: '500px', margin: '0 auto' }}>
          <h1 className="text-4xl font-bold text-primary mb-4">
            Welcome to the AI Readiness Assessment
          </h1>
          <p className="text-secondary mb-6">
            Take the AI Readiness Assessment to see how ready your organization is for AI.
          </p>
          <div>
            <Link to="/form" className="btn btn-primary btn-lg">
Start the Quiz!            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
